import { render } from "./ServiceToken.vue?vue&type=template&id=cb2e3e14"
import script from "./ServiceToken.vue?vue&type=script&lang=js"
export * from "./ServiceToken.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__